import { Component, OnInit } from '@angular/core';
import { Message } from 'primeng/components/common/api';
import { GenericComponent } from '../../../../layouts/custom-component/generic-component';
import { FormBuilder } from '@angular/forms';
import { TestService } from '../_service/TestService';
import { md5 } from '../md5';
import { PulsanteService } from '../_service/PulsanteService';
import { Utils } from '../../../../../utils';
import { Tester } from '../../../../../auth/_models/tester';
import { environment } from '../../../../../../environments/environment';
import { Utente_testService } from '../_service/Utente_testService';
import { LogService } from '../_service/LogService';
import { Log } from '../_model/Log';
import { Elliptic } from '../elliptic.encryption';


@Component({
    selector: ".m-grid__item.m-grid__item--fluid.m-wrapper",
    templateUrl: 'utente.component.html',
    providers: [TestService, PulsanteService, Utente_testService, LogService]
})
export class UtenteComponent extends GenericComponent {

    /*
    - legame utente - questionario
    */

    /*
    - password generale ogni x secondi
    - password ad ogni pulsante
    - punteggio realizzato (ogni volta che metto password ok, verifica file prima di scaricarlo, mouseover sul link)
    - (se punteggio relizzato > x) non chiedere la password
    
    - punteggio_password = 1
    - punteggio verifica = 2
    - punteggio mouseover = 3

    */



    currEmail: number = null;
    emails: any = [];
    emailToShow: any = null;
    timer: number = 0;
    //timerString: string = "00:00:00";
    timerString: string = "";
    inbox: any = [];

    hours: number = 0;
    minutes: number = 0;
    seconds: number = 0;

    showEmail: boolean = false;
    showPulsanti: boolean = false;

    audio_mp3: string = null;

    displayDialogPassword: boolean = false;
    displayDialogPasswordScreenSaver: boolean = false;
    passwordInserita: string = null;
    passwordInseritaScreenSaver: string = null;

    passwordsOk: number = 0;
    //tmpIncremento: number = 0;
    tempoPassatoDaUltimaRispostaCorretta: number = 0;
    ultimaCorretta: boolean = false;

    tempoPassatoDaUltimoConsumoToken: number = 0;

    currPulsante: any = null;
    questionario: any = null;

    punteggioGenerale: number = 0;
    pulsantiArr: any = null;
    //test : AudioComponent = null;
    displayDialogRispondi: boolean = false;
    displayDialogConsumaPremio: boolean = false;

    nEmailCatalogate: number = 0;
    stoCatalogandoEmail: boolean = false;


    questionarioFinito: boolean = false;
    allegatoChecked: boolean = false;
    clickChecked: boolean = false;

    idleTime: number = 0;
    risposta: string = "";
    testoScritto: string = "";

    punteggioMouseOver: number = 0;
    punteggioScreenSaver: number = 0;

    //mouseOutFromLink: boolean = false;

    currentTester: Tester = null;
    questionariArr: any[] = null;

    punteggioPerAaggiungereToken: number = 999;
    tempoPerAaggiungereToken: number = 999;

    punteggioPerVisualizzareFeedback: number = 999;
    currPunteggiFeedback: any = {};

    punteggioPerConsumareToken: number = 999;
    tempoPerConsumareToken: number = 999;

    punteggioAccumulatoPerConsumare: number = 0;

    urlImage: String = null;
    premiGuadagnati: any = null;

    currTesterID: string = null;

    currLogScreenSaverID: number = null;

    headerPremio: string = "";

    sequenzaPerConsumareToken: any[] = null;
    numeroAssegnazioniToken: number = -1;

    encs: any = {};

    constructor(private fb: FormBuilder, private ts: TestService, private ps: PulsanteService, private uts: Utente_testService, private ls: LogService) {
        //this.removeMenuLeft();
        super(ts);

    }



    ngAfterViewInit() {
        this.removeMenuLeft();
        this.removeHeader();
        $(document).on('keydown', function (e) { //per evitare che quando premo lo spazio si preme il bottone dei premi
            if ($(document.activeElement).is('button') &&
                (e.keyCode === 13 || e.keyCode === 32))
                e.preventDefault();
        });
    }

    ngOnInit() {

        this.premiGuadagnati = {};
        this.msgs = [];
        this.urlImage = environment.URL_IMAGE;

        this.currentTester = new Tester();
        this.currentTester.genere = "M";
        this.currentTester.logged = false;
        this.currentTester.token_partenza = 0;

        let that = this;
        this.blockedUI = true;
        this.ts.getAll().then((retdata) => {

            this.blockedUI = false;

            if (retdata.response == 0) {
                that.questionariArr = retdata.data.testList;

            } else {
                this.showMessageError(retdata);
            }
        });


        /* DA TOGLIERE */
        // setTimeout(function () {
        //     that.iniziaTestProva();
        // }, 500);
        /* FINE DA TOGLIERE */


    }



    getUrlImage(testo: string) {
        return this.urlImage + "?e=" + this.encs[testo];
    }

    encryp(testo: string) {
        if (testo == "" || testo == undefined) {
            return "";
        }
        return Elliptic.b64encPHP(testo, Utils.getNonceKey(), Utils.getEncKey());
    }

    iniziaTestProva() {

        this.currentTester = new Tester();
        this.currentTester.genere = "M";
        this.currentTester.logged = true;
        this.currentTester.nome = "Mario";
        this.currentTester.cognome = "Rossi";
        this.currentTester.anni = "12";
        this.currentTester.test = { "id": 11 };

        this.entra();
    }




    entra() {

        if (
            this.currentTester.cognome == null
            || this.currentTester.test == null
        ) {
            //alert("Tutti i campi sono obbligatori");
            this.showMessageError({ "errors": "Tutti i campi sono obbligatori" });
        } else {

            this.currentTester.logged = true;
            this.updateTimer();
            this.loading = true;
            let that = this;

            this.pulsantiArr = [];
            this.ps.getById(this.currentTester.test.id).then((retdata) => {

                Utils.log("PULSANTI: ", retdata);
                if (retdata.response == 0) {
                    that.pulsantiArr = retdata.data.pulsanteList;
                } else {
                    this.showMessageError(retdata);
                }
            });

            $("html").mousemove(function () {
                that.idleTime = 0;
            });

            $("html").keypress(function () {
                that.idleTime = 0;
            });



            this.ts.getById(this.currentTester.test.id).then((retdata) => {
                //Utils.log(retdata);

                //that.audio_mp3 = "http://localhost/test/test.mp3";

                this.loading = false;

                if (retdata.response == 0) {

                    if (retdata.data.test != undefined) {
                        that.questionario = retdata.data.test;
                        that.currentTester.test_id = that.questionario.id;
                        //console.log("QQQQQ", that.questionario, that.questionario.tipoScambioSecEmail);


                        var avvia_audio = true;
                        //$('#id-col-area_scrittura').hide();
                        // if (retdata.data.test.area_scrittura != 1) {
                        //     $('#id-col-area_scrittura').hide();
                        //     avvia_audio = false;
                        // }

                        $('#container-email').css('height', window.innerHeight - 150 - 155);
                        $('.ui-editor-container').css('height', window.innerHeight - 190);


                        //inserisco il log di primo avvio
                        that.uts.create(that.currentTester).then((_retdata) => {

                            that.currTesterID = _retdata.data.utente_test.id;

                            that.emails = retdata.data.test.emailsObj;
                            that.currEmail = 0;
                            if (that.emails.length > 0) {
                                let email = that.emails[0];
                                //that.pushEmail(email.start_delay * 1000);
                                that.pushEmail(0);
                            }

                            that.audio_mp3 = that.questionario.audio.file;

                            that.punteggioMouseOver = 0;
                            //that.punteggioMouseOver = (that.questionario.pMouseOver != null) ? 1 : 0;
                            that.punteggioScreenSaver = 0;
                            //that.punteggioScreenSaver = (that.questionario.pScreenSaver != null) ? 1 : 0;

                            that.inizializzaPunteggioPerAggiungereToken();
                            that.inizializzaPunteggioPerConsumareToken();

                            that.inizializzaPunteggioPerAssegnazioneFeedback();
                            that.currPunteggiFeedback = {};

                            if (that.currentTester.token_partenza > 0) {
                                that.punteggioGenerale = 1 * that.currentTester.token_partenza + 0;
                                that.punteggioAccumulatoPerConsumare = 1 * that.currentTester.token_partenza + 0;
                            }

                            //console.log(that.questionario);
                            //mettere qui --------------
                            if (true || that.questionario.soloPulsanti == 1) {
                                that.headerPremio = "Complimenti!! :D Grazie al punteggio ottenuto hai diritto ad un premio! Sblocca l'inserimento della password";
                                let premi_tempo = that.questionario.premi_tempo;
                                if (premi_tempo != undefined && premi_tempo.length == 1) {
                                    let pt = premi_tempo[0];
                                    //YYYYYY

                                    if (this.questionario.tipoScambioSecEmail == 1) {
                                        that.headerPremio += " per " + pt.tempo + " email";
                                    } else {
                                        that.headerPremio += " per " + pt.tempo + " secondi";
                                    }

                                    pt.nome = "Applica";
                                    that.questionario.premi_tempo[0] = pt;
                                }

                            }
                            // else if (that.questionario.tipoScambio == 1 || that.questionario.tipoScambio == 2) {
                            //     that.headerPremio = "Complimenti!!! :D grazie al punteggio ottenuto hai diritto ad un premio! Sblocca la password di una categoria a tua scelta.";
                            // }
                            // else if (that.questionario.tipoScambio == 3 || that.questionario.tipoScambio == 4) {
                            //     that.headerPremio = "Complimenti!!! :D è giunto il momento di scegliere un premio! Sblocca la password di una categoria a tua scelta."
                            // }

                            setTimeout(function () {
                                that.playAudio();
                            }, 1000);


                        });


                    }

                } else {
                    this.showMessageError(retdata);
                }
            });



        }



    }

    generaSequenzaPunteggiPerConsumareToken(nDomande: number, vr: number) {

        var x = (nDomande - 1) / vr;
        var nCombinazioni = Math.floor(x);
        var out = [];

        var somma = 0;
        for (var i = 0; i < nCombinazioni - 1; i++) {

            let x = Math.floor((Math.random() * 10) + 1);
            out.push(x);
            somma += x;
        }

        let last = (nCombinazioni * vr) - somma;
        out.push(last);

        return out;
    }


    inizializzaPunteggioPerConsumareToken() {

        if (this.sequenzaPerConsumareToken == null) {
            this.sequenzaPerConsumareToken = this.generaSequenzaPunteggiPerConsumareToken(this.emails.length, this.questionario.valoreInizialeScambio);
        }
        this.numeroAssegnazioniToken++;
        var indiceArraySequenza = this.numeroAssegnazioniToken % this.sequenzaPerConsumareToken.length;
        var valorePunteggioPerConsumareToken = this.sequenzaPerConsumareToken[indiceArraySequenza];
        Utils.log("INDICE: " + indiceArraySequenza + " | VALORE: " + valorePunteggioPerConsumareToken);

        this.punteggioPerConsumareToken = 0;
        this.tempoPerConsumareToken = 0;

        this.punteggioAccumulatoPerConsumare = 0;
        this.tempoPassatoDaUltimoConsumoToken = 0;

        if (this.questionario != null) {
            if (this.questionario.tipoScambio == 1) {
                this.punteggioPerConsumareToken = this.questionario.valoreInizialeScambio;
                Utils.log("HO SETTATO SCAMBIO FISSO: " + this.punteggioPerConsumareToken)
            }
            else if (this.questionario.tipoScambio == 2) {
                //this.punteggioPerConsumareToken = Utils.randomNumber(this.questionario.valoreInizialeScambio, this.questionario.valoreFinaleScambio);
                this.punteggioPerConsumareToken = valorePunteggioPerConsumareToken;
                Utils.log("HO SETTATO SCAMBIO RANDOM: " + this.punteggioPerConsumareToken);
            }
            else if (this.questionario.tipoScambio == 3) {
                this.tempoPerConsumareToken = this.questionario.valoreInizialeScambio;
                Utils.log("HO SETTATO SCAMBIO TEMPO FISSO: " + this.punteggioPerConsumareToken)
            }
            else if (this.questionario.tipoScambio == 4) {
                this.tempoPerConsumareToken = Utils.randomNumber(this.questionario.valoreInizialeScambio, this.questionario.valoreFinaleScambio);
                Utils.log("HO SETTATO TEMPO SCAMBIO RANDOM: " + this.tempoPerConsumareToken);
            }
        }

    }

    inizializzaPunteggioPerAssegnazioneFeedback() {

        /*
        this.punteggioPerVisualizzareFeedback = 9999;

        if (this.questionario != null) {

            if (this.questionario.tipoAssegnazioneFeedback == 1) {
                this.punteggioPerVisualizzareFeedback = this.questionario.valoreInizialeAssegnazioneFeedback;
                Utils.log("HO SETTATO FEEDBACK FISSO: " + this.punteggioPerVisualizzareFeedback);
            }
                this.punteggioPerVisualizzareFeedback = Utils.randomNumber(this.questionario.valoreInizialeAssegnazioneFeedback, this.questionario.valoreFinaleAssegnazioneFeedback);
                Utils.log("HO SETTATO FEEDBACK RANDOM: " + this.punteggioPerVisualizzareFeedback);
            }
        }*/

    }

    inizializzaPunteggioPerAggiungereToken() {

        this.passwordsOk = 0;
        this.tempoPerAaggiungereToken = 0;
        this.punteggioPerAaggiungereToken = 0;

        if (this.questionario != null) {
            if (this.questionario.tipo == 1) {
                this.punteggioPerAaggiungereToken = this.questionario.valoreIniziale;
                Utils.log("HO SETTATO PUNTEGGIO FISSO: " + this.punteggioPerAaggiungereToken);


            }
            else if (this.questionario.tipo == 2) {
                this.punteggioPerAaggiungereToken = Utils.randomNumber(this.questionario.valoreIniziale, this.questionario.valoreFinale);
                Utils.log("HO SETTATO PUNTEGGIO RANDOM: " + this.punteggioPerAaggiungereToken);

                //console.log("nuovo valore token: " + this.punteggioPerAaggiungereToken);

            }
            else if (this.questionario.tipo == 3) {
                this.tempoPerAaggiungereToken = this.questionario.valoreIniziale;
                Utils.log("HO SETTATO TEMPO FISSO: " + this.tempoPerAaggiungereToken);
            }
            else if (this.questionario.tipo == 4) {
                this.tempoPerAaggiungereToken = Utils.randomNumber(this.questionario.valoreIniziale, this.questionario.valoreFinale);
                Utils.log("HO SETTATO TEMPO RANDOM: " + this.tempoPerAaggiungereToken);

                //console.log("nuovo valore tempo: " + this.tempoPerAaggiungereToken);
            }
        }


    }

    esci() {
        this.currentTester = new Tester();
        this.currentTester.genere = "M";
        this.currentTester.logged = false;

    }

    private inviaLog(log: Log) {

        Utils.log("INSERISCO LOG", log);

        log.q_testo = this.getNumCaratteriScritti();
        var that = this;
        this.ls.create(log).then((retdata) => {
            if (log.evento == "SS") {
                that.currLogScreenSaverID = retdata.data.log.id;
                Utils.log(that.currLogScreenSaverID);
            }
        });
    }

    inserisciLogMouseOver(email: any, effettuto: number) {

        let log = new Log();
        log.email_id = email.id;
        log.utente_test_id = this.currTesterID;
        log.mouseover_effettuato = effettuto;

        this.inviaLog(log);

    }

    inserisciLogClick(email: any, effettuto: number) {

        let log = new Log();
        log.email_id = email.id;
        log.utente_test_id = this.currTesterID;
        log.click_effettuato = effettuto;

        this.inviaLog(log);

    }


    inserisciLogArrivoEmail(email: any) {

        let log = new Log();
        log.email_id = email.id;
        log.evento = "Email_" + email.id;

        log.utente_test_id = this.currTesterID;
        log.t_arrivo = this.timer;

        this.inviaLog(log);
    }

    inserisciLogAperturaEmail(email: any) {

        let log = new Log();
        log.utente_test_id = this.currTesterID;
        log.email_id = email.id;
        log.t_apertura = this.timer;
        log.mouseover_disp = (this.punteggioMouseOver > 0) ? 1 : 0;

        this.inviaLog(log);
    }

    inserisciLogPulsanteEmail(email: any, pulsante: any) {

        let log = new Log();

        log.cat_scelta = pulsante.id;
        log.cat_email = email.tipo_id;
        log.t_cat = this.timer;
        log.email_id = email.id;
        log.utente_test_id = this.currTesterID;

        Utils.log("inserisciLogPulsanteEmail", log);

        this.inviaLog(log);
    }

    inserisciLogConfermaPulsante(email: any, token: number) {

        let log = new Log();

        log.t_conferma = this.timer;
        log.email_id = email.id;
        log.token = token;
        log.utente_test_id = this.currTesterID;

        this.inviaLog(log);
    }

    inserisciLogConfermaPremio(premio: number, tempo: number) {

        let log = new Log();

        log.t_arrivo = this.timer;
        log.evento = "scambio token";
        log.premio_durata = tempo;
        log.premio_sel = premio;
        log.token = this.punteggioGenerale;
        log.utente_test_id = this.currTesterID;

        Utils.log("SCAMBIO_TOKEN", log);

        this.inviaLog(log);
    }







    inserisciLogScreenSaver() {
        let log = new Log();
        log.evento = "SS";
        log.t_arrivo = this.timer;
        log.utente_test_id = this.currTesterID;
        this.inviaLog(log);
    }

    inserisciLogSbloccoScreenSaver() {

        let log = new Log();
        log.t_screensaver = this.timer;
        log.id = this.currLogScreenSaverID;
        log.token = this.punteggioScreenSaver;

        this.currLogScreenSaverID = null;

        Utils.log(log);
        this.inviaLog(log);
    }


    notificaEmail(email: any) {
        this.inserisciLogArrivoEmail(email);
        this.showInfoMessage('Nuova email', "Da: " + email.mittente + "<br>" + email.oggetto);
        this.inbox.splice(0, 0, email);

    }

    shuffleArray(array: any[]) {
        var m = array.length, t, i;

        // While there remain elements to shuffle
        while (m) {
            // Pick a remaining element…
            i = Math.floor(Math.random() * m--);

            // And swap it with the current element.
            t = array[m];
            array[m] = array[i];
            array[i] = t;
        }

        return array;

    }

    printEmail(email: any) {

        if (email == null) {
            return;
        }

        //if (this.questionario.ordineForzato == 1) { //se è ordine forzato posso aprire soltanto la prima email della coda
        if (true) { //se è ordine forzato posso aprire soltanto la prima email della coda

            var i = 0;
            if (this.inbox.length > 0) {
                let m = this.inbox[0];

                if (m['id'] != email['id']) {
                    return;
                }
            }
        }

        if (email != null && this.emailToShow != null && email.id == this.emailToShow.id) {
            return;
        }

        if (this.emailToShow != null) {
            $('#td-' + this.emailToShow.id).css('background-color', "rgba(0,0,0,0)");
        }

        $('#td-' + email.id).css('background-color', "lightblue");

        $('#container-email').scrollTop(0);

        this.showPulsanti = false;
        this.pulsantiArr = this.shuffleArray(this.pulsantiArr);
        this.risposta = "";
        this.allegatoChecked = false;
        this.clickChecked = false;
        this.showEmail = true;
        this.emailToShow = email;

        let that = this;


        setTimeout(function () {
            that.showPulsanti = true;
        }, this.questionario.ritardoPulsanti * 1000);

        this.inserisciLogAperturaEmail(email);

        var timer = null;


        setTimeout(function () {
            $(".link_front_end").click(function () {
                if (that.clickChecked == false) {
                    that.inserisciLogClick(that.emailToShow, 1);
                    that.clickChecked = true;
                }
                return false;
            })
        }, 200);


        setTimeout(function () {


            $(".link_front_end").mouseover(function () {
                if (timer != null) {
                    clearTimeout(timer);
                }
                timer = setTimeout(function () {

                    Utils.log("finito il timer");
                    if (that.allegatoChecked == false) {
                        that.inserisciLogMouseOver(that.emailToShow, 1);
                        that.aggiornaPunteggioGenerale(that.punteggioMouseOver, false);
                    }
                    that.allegatoChecked = true;
                }, 2.5 * 1000);
            });

            $(".link_front_end").mouseout(function () {
                if (timer != null) {
                    clearTimeout(timer);
                }
                timer = null;
            });
        }, 200);

    }

    pushEmail(delay: number) {

        let that = this;
        setTimeout(function () {

            //Utils.log(that.emails,that.currEmail,that.emails.length);
            let email = that.emails[that.currEmail];
            that.notificaEmail(email.email);
            that.currEmail = that.currEmail + 1;

            if (that.emails.length > that.currEmail) {
                let nextEmail = that.emails[that.currEmail];
                //that.pushEmail(nextEmail.start_delay * 1000);
                that.pushEmail(0);
            }
        }, delay);

    }

    updateTimer() {

        var that = this;
        setTimeout(function () {

            // if (that.displayDialogPassword == false && that.questionario != undefined && that.idleTime > that.questionario.timeoutPassword) {
            //     that.showDialogPasswordScreenSaver();
            // }


            if (!that.displayDialogConsumaPremio) {

                if (that.ultimaCorretta == true) {
                    that.tempoPassatoDaUltimaRispostaCorretta = that.tempoPassatoDaUltimaRispostaCorretta + 1;
                }

                that.tempoPassatoDaUltimoConsumoToken = that.tempoPassatoDaUltimoConsumoToken + 1;

                //Utils.log("PREMI_GUADAGNATI: ", that.premiGuadagnati);

                Object.keys(that.premiGuadagnati).forEach(key => {
                    let value = that.premiGuadagnati[key];
                    if (value <= 0) {
                        delete (that.premiGuadagnati[key]);
                    } else {
                        that.premiGuadagnati[key] = Number(value - 1);
                    }


                });
            }


            that.idleTime = that.idleTime + 1;
            that.timer = that.timer + 1;

            //questo perché posso consumare su base temporale, 
            //a prescindere se ho raggiunto o meno un numero x di token
            that.checkSeConsumareTokenATempo();

            //if (that.questionario != null && that.questionario['durata'] != undefined && that.timer >= that.questionario['durata']) {
            //console.log("TIMER", that.timer);
            if (that.timer > 10 && that.questionario != null && that.inbox.length == 0 && that.emailToShow == null) {
                if (that.questionarioFinito == false) {
                    that.uts.update({
                        id: that.currTesterID,
                        data_fine: "FINE",
                        caratteri: that.getNumCaratteriScritti(),
                        testo: that.testoScritto,
                        token: that.punteggioGenerale
                    }).then((retdata) => {
                        //Utils.log(retdata);
                    });
                }

                that.questionarioFinito = true;
                that.displayDialogPassword = false;
                that.displayDialogRispondi = false;
                that.displayDialogConsumaPremio = false;
            }

            /*
            that.seconds = that.seconds + 1;
            if (that.timer > 0 && that.timer % 60 == 0) {
                that.minutes = that.minutes + 1;
                that.seconds = 0;
            }
            if (that.minutes > 0 && that.minutes % 60 == 0) {
                that.hours = that.hours + 1;
                that.minutes = 0;
            }

            var h = "" + that.hours;
            if (that.hours < 10) {
                h = "0" + h;
            }
            var m = "" + that.minutes;
            if (that.minutes < 10) {
                m = "0" + m;
            }
            var s = "" + that.seconds;
            if (that.seconds < 10) {
                s = "0" + s;
            }

            that.timerString = h + ":" + m + ":" + s;
            */

            if (!that.questionarioFinito) {
                that.updateTimer();
            }


        }, 1000);

    }

    getNumCaratteriScritti() {

        if (this.testoScritto != null) {
            var str = this.testoScritto;
            str = str.replace(/<(?:.|\n)*?>/gm, '');
            return str.length;
        }
        return 0;
    }


    resetTempoPassatoDaUltimaRispostaCorretta() {
        this.ultimaCorretta = true;
        this.tempoPassatoDaUltimaRispostaCorretta = 0;
    }

    checkPasswordScreenSaver(aggiornaPunteggio: boolean) {


        //Utils.log(this.questionario.password + " VS " + this.passwordInseritaScreenSaver);

        if (this.questionario.password != this.passwordInseritaScreenSaver) {

            this.ultimaCorretta = false;
            this.passwordInseritaScreenSaver = "";
        } else {
            this.aggiornaPunteggioGenerale(aggiornaPunteggio ? this.punteggioScreenSaver : 0, false);
            this.hideDialogPasswordScreenSaver();

            if (aggiornaPunteggio) {
                this.inserisciLogSbloccoScreenSaver();
            } else {
                this.currLogScreenSaverID = null;
            }


        }
        this.idleTime = 0;
    }


    cancelPassword() {
        this.displayDialogPassword = false;
        this.passwordInserita = "";
        //this.playAudio();
    }

    checkPassword() {

        Utils.log("CHECK_PASSWORD", this.currPulsante);

        if (this.currPulsante != null) {

            if (this.currPulsante.password != this.passwordInserita) {
                this.passwordInserita = "";
            }


            else { //la password è ok


                if (!this.stoConsumandoPremio()) {
                    if (
                        this.currPulsante.id == this.emailToShow.tipo_id
                    ) {
                        var incremento = 1;
                        if (this.currPulsante.token != null) {
                            incremento = this.currPulsante.token;

                            var oldValore = this.currPunteggiFeedback[this.currPulsante.categoria];
                            if (!oldValore) {
                                oldValore = 0;
                            }
                            this.currPunteggiFeedback[this.currPulsante.categoria] = 1 * oldValore + 1 * incremento;
                            this.checkSeVisualizzareFeedback(this.currPulsante);
                        }

                        this.aggiornaPunteggioGenerale(+incremento, true);
                        this.popEmail();

                    } else {


                        var decremento = 0;
                        if (this.currPulsante.token_errato != null) {

                            decremento = this.currPulsante.token_errato;
                            var oldValore = this.currPunteggiFeedback[this.currPulsante.categoria];

                            if (!oldValore) {
                                oldValore = 0;
                            }

                            decremento = (decremento) * -1;
                            this.currPunteggiFeedback[this.currPulsante.categoria] = 1 * oldValore + 1 * decremento;
                            this.checkSeVisualizzareFeedback(this.currPulsante);
                            this.aggiornaPunteggioGenerale(+decremento, true);

                        }




                        if (this.questionario.loopEmail == 1 || this.questionario.loopEmail == true) {
                            this.spostaEmailInCoda();
                        } else {
                            this.popEmail();
                        }
                        //this.spostaEmailInCoda();

                        if (this.emailToShow != null) {
                            $('#td-' + this.emailToShow['id']).css('background-color', "rgba(0,0,0,0)");
                        }
                        this.inserisciLogConfermaPulsante(this.emailToShow, 0); //l'altro log lo mando doppo aver calcolato il numero di token
                    }
                } else {

                    this.nEmailCatalogate = this.nEmailCatalogate + 1;
                    if (this.questionario != null && this.questionario.tipoScambioSecEmail == 1) {
                        let premi_filtered = this.questionario.premi_tempo.filter(p => {
                            return p['pulsante_id'] == 98
                        });

                        if (premi_filtered.length == 1) {
                            let premio = premi_filtered[0];

                            if (this.nEmailCatalogate >= premio.tempo) {

                                this.nEmailCatalogate = 0;
                                this.stoCatalogandoEmail = false;
                                Utils.log("2. CAMBIO STO CATALOGANDO: ", this.stoCatalogandoEmail);
                            }
                        }

                    }

                    //ho categorizzato correttamente la mail
                    if (this.currPulsante.id == this.emailToShow.tipo_id) {
                        this.popEmail();
                    } else {
                        if (this.questionario.loopEmail == 1 || this.questionario.loopEmail == true) {
                            this.spostaEmailInCoda();
                        } else {
                            this.popEmail();
                        }
                        //this.spostaEmailInCoda();
                    }


                }


                this.hideDialogPassword();
                this.showEmail = false;
                this.emailToShow = null;
                this.showPulsanti = false;

                //this.playAudio();
            }
        }
    }

    hideDialogPasswordScreenSaver() {

        this.displayDialogPasswordScreenSaver = false;
        this.passwordInseritaScreenSaver = null;

        $('.ui-widget-overlay').css('background-image', "");
        $('.ui-widget-overlay').css('opacity', "0.7");

    }

    hideDialogPassword() {

        this.currPulsante = null;
        this.displayDialogPassword = false;
        this.passwordInserita = null;
        this.displayDialogRispondi = false;

        $('.ui-widget-overlay').css('background-image', "");
        $('.ui-widget-overlay').css('opacity', "0.7");

    }

    pulsanteClicked(pulsante: any) {

        this.currPulsante = pulsante;

        this.inserisciLogPulsanteEmail(this.emailToShow, pulsante);

        if (pulsante['id'] == 6) { //rispondi al mittente
            this.displayDialogRispondi = true;
        }
        else {
            this.showDialogPassword();

        }
    }



    aggiornaPunteggioGenerale(incremento: number, isPulsante: boolean) {
        Utils.log("INCREMENTO: ", incremento);
        //this.punteggioGenerale = Number(this.punteggioGenerale) + Number(incremento);
        //in base al tipo di questionario devo capire se assegnare il token o meno



        if (this.questionario != null) {

            if (incremento >= 0) { //non sto consumando token
                this.ultimaCorretta = false;
            }

            if (incremento > 0) {


                this.passwordsOk = this.passwordsOk + 1;
                //this.tmpIncremento += incremento;

                this.ultimaCorretta = true;

                var incrementoReale: number = 0;
                if (this.questionario.tipo == 1 || this.questionario.tipo == 2) {
                    Utils.log(this.punteggioPerAaggiungereToken + " VS " + this.passwordsOk);
                    if (this.passwordsOk >= this.punteggioPerAaggiungereToken) {
                        incrementoReale = incremento;
                    }
                }
                if (this.questionario.tipo == 3 || this.questionario.tipo == 4) {
                    Utils.log("ULTIMA_CORRETTA: " + this.tempoPassatoDaUltimaRispostaCorretta + " VS " + this.tempoPerAaggiungereToken);
                    if (this.tempoPassatoDaUltimaRispostaCorretta >= this.tempoPerAaggiungereToken) {
                        incrementoReale = incremento;
                    }
                }

                Utils.log("INCREMENTO REALE: " + incrementoReale);

                if (incrementoReale > 0) {
                    this.feedbackIncrementoPunteggio();
                    this.punteggioGenerale = this.punteggioGenerale + incrementoReale; //assegno il token
                    this.punteggioAccumulatoPerConsumare = this.punteggioAccumulatoPerConsumare + incrementoReale;
                    this.checkSeConsumareToken();
                    this.inizializzaPunteggioPerAggiungereToken(); //riparto da zero
                }


                if (isPulsante) {
                    this.inserisciLogConfermaPulsante(this.emailToShow, incrementoReale);
                }

                if (this.tempoPassatoDaUltimaRispostaCorretta >= this.tempoPerAaggiungereToken) {
                    this.resetTempoPassatoDaUltimaRispostaCorretta();
                }
            } else { //in questo caso è negativo, sto consumando un premio
                this.punteggioGenerale = this.punteggioGenerale + incremento;

                if (incremento < 0) {
                    if (isPulsante) {
                        this.feedbackDecrementoPunteggio();
                    }

                }
            }


        }



    }

    feedbackDecrementoPunteggio() {

        let audio = new Audio();
        audio.src = "./assets/app/media/audio/fail-buzzer-04.wav";
        audio.load();
        audio.play();

    }

    feedbackIncrementoPunteggio() {

        let audio = new Audio();
        audio.src = "./assets/app/media/audio/alarm.wav";
        audio.load();
        audio.play();


        $('#label-punteggio').css('background', 'white');
        $('#label-punteggio').css('color', '#212529');

        setTimeout(function () {
            $('#label-punteggio').css('background', 'rgba(0,0,0,0)');
            $('#label-punteggio').css('color', 'white');
        }, 500);



        //lampeggia la label del punteggio in alto a destra
        //emette un piccolo suono tipo "tinnnn" per far capire che ha guadagnato un punto
    }

    annullaPremio() {

        this.displayDialogConsumaPremio = false;
        this.inserisciLogConfermaPremio(-1, -1);

        //this.ultimaCorretta = false;
        //this.tempoPassatoDaUltimaRispostaCorretta = 0;

    }



    hideDialogPremio(pulsante: number, tempo: number, costo: number) {

        if (this.premiGuadagnati[pulsante] == null || this.premiGuadagnati[pulsante] < 0) {
            this.premiGuadagnati[pulsante] = 0;
        }

        this.premiGuadagnati[pulsante] += Number(tempo);

        Utils.log("PERMI: ", this.premiGuadagnati);
        this.displayDialogConsumaPremio = false;

        this.inserisciLogConfermaPremio(pulsante, tempo);

        this.aggiornaPunteggioGenerale(-costo, false);

        //this.ultimaCorretta = false;
        //this.tempoPassatoDaUltimaRispostaCorretta = 0;

    }

    premiGuadagnatiToArr() {

        var ret = [];


        if (this.premiGuadagnati != null) {

            /*
            this.premiGuadagnati.forEach(element => {
                ret.push(element.key + ": " + element.value);
            });
            */

            Object.keys(this.premiGuadagnati).forEach(key => {
                let value = this.premiGuadagnati[key];
                if (value != null && value > 0) {
                    ret.push(`${key}: ${value}`);
                }
            });
        }

        return ret;

    }

    consumaToken() {

        //controllo se c'è almeno un premio con costo minore del mio punteggio generale

        if (this.questionario != null
            && this.questionario.premi.length > 0
            && this.questionario.premi_tempo.length > 0
        ) {


            var posso_mostrare_dialog = false;
            for (var i = 0; i < this.questionario.premi_tempo.length; i++) {
                let premio = this.questionario.premi_tempo[i];

                if (premio.costo <= this.punteggioGenerale) {
                    posso_mostrare_dialog = true;
                    break;
                }
            }


            if (posso_mostrare_dialog) {
                this.displayDialogConsumaPremio = true;
                this.inizializzaPunteggioPerConsumareToken();

                this.nEmailCatalogate = 0;
                this.stoCatalogandoEmail = true;
                Utils.log("1 CAMBIO STO CATALOGANDO: ", this.stoCatalogandoEmail);

            }
        }


    }

    checkSeConsumareTokenATempo() {

        if (this.displayDialogPasswordScreenSaver == false && this.questionario != null) {

            if (this.questionario.tipoScambio == 3 || this.questionario.tipoScambio == 4) {
                //Utils.log("CONSUMO: "+this.tempoPassatoDaUltimoConsumoToken + " VS " + this.tempoPerConsumareToken);
                if (this.tempoPassatoDaUltimoConsumoToken >= this.tempoPerConsumareToken) {


                    this.consumaToken();

                }
            }

        }
    }

    checkSeVisualizzareFeedback(pulsante) {
        /*
        Utils.log("checkSeVisualizzareFeedback! => " + this.currPunteggiFeedback);
        if (this.questionario.tipoAssegnazioneFeedback == 1 || this.questionario.tipoAssegnazioneFeedback == 2) {

            if (
                pulsante.feedback != null
                && pulsante.feedback != undefined
                && pulsante.feedback != "") {

                var punteggioPulsante = this.currPunteggiFeedback[pulsante.categoria];

                if (punteggioPulsante >= this.punteggioPerVisualizzareFeedback) {
                    punteggioPulsante -= this.punteggioPerVisualizzareFeedback;
                    this.currPunteggiFeedback[pulsante.categoria] = punteggioPulsante;
                    this.showInfoMessage('Feedback', pulsante.feedback);

                }
            }

        }*/
    }

    checkSeConsumareToken() {

        Utils.log("checkSeConsumareToken");

        if (
            this.questionario.tipoScambio == 1
            || this.questionario.tipoScambio == 2) {

            Utils.log("CONSUMO: " + this.punteggioAccumulatoPerConsumare + " VS " + this.punteggioPerConsumareToken);

            if (this.punteggioAccumulatoPerConsumare >= this.punteggioPerConsumareToken) {
                this.consumaToken();
            }
        }

    }

    pauseAudio() {

        /*
        let audio = <HTMLAudioElement>document.getElementById("audio");
        if (audio != undefined) {
            audio.pause();
        }*/

    }

    playAudio() {

        /*
        let audio = <HTMLAudioElement>document.getElementById("audio");
        if (audio != undefined) {
            audio.play();
        }*/

    }

    showDialogPasswordScreenSaver() {

        if (this.questionarioFinito) {
            return;
        }

        Utils.log("check bonus screensaver");
        if (this.hoBonusPerPulsante(99) || this.hoBonusPerPulsante(98)) {

            Utils.log("ho il bonus screensaver... questa volta salto");

            let passwordFake = "skip";
            this.questionario.password = passwordFake;
            this.passwordInseritaScreenSaver = passwordFake;

            this.checkPasswordScreenSaver(false);
            return;
        }

        this.pauseAudio();

        if (this.displayDialogPassword == false && this.displayDialogPasswordScreenSaver == false) {

            this.inserisciLogScreenSaver();

            let tmpPass = this.generatoRandomPassword();

            this.questionario.password = tmpPass;
            this.displayDialogPasswordScreenSaver = true;

            setTimeout(function () {
                $('.ui-widget-overlay').css('background-image', "url('./assets/app/media/img/bg/bg-4.jpg')");
                $('.ui-widget-overlay').css('opacity', "1");
            }, 100);
        }
    }

    generatoRandomPassword() {
        let tmpPass = Utils.randomString(10);
        if (tmpPass != undefined && this.encs[tmpPass] == undefined) {
            let enc = this.encryp(tmpPass);
            this.encs[tmpPass] = enc;
        }
        return tmpPass;
    }

    stoConsumandoPremio() {

        if (this.questionario != null && this.questionario.tipoScambioSecEmail == 1) {
            return (this.stoCatalogandoEmail == true);
        }

        return (
            this.premiGuadagnati != null
            &&
            Object.keys(this.premiGuadagnati).length > 0
        );
    }

    hoBonusPerPulsante(id: number) {

        if (id == 98 && this.questionario != null && this.questionario.tipoScambioSecEmail == 1) {
            return (this.stoCatalogandoEmail == true);
        } else {
            let tempo = this.premiGuadagnati[id];
            return (tempo > 0);
        }



    }

    getStringaSePremioAttivo(premio: any) {


        let id = premio.pulsante_id;
        var ret = premio.nome;

        return ret;

    }


    showDialogPassword() {

        this.pauseAudio();

        this.currPulsante.password = this.generatoRandomPassword();

        if (this.hoBonusPerPulsante(98)) {
            Utils.log("***** ho il bonus per tutte le password *****");
        }

        if (this.currPulsante != null && (this.hoBonusPerPulsante(this.currPulsante['id']) || this.hoBonusPerPulsante(98))) {
            this.passwordInserita = this.currPulsante.password;
            this.checkPassword();
            return;
        }

        if (this.questionario != null) {
            this.displayDialogPassword = true;
        }
    }


    popEmail() {
        if (this.emailToShow != null) {
            var i = 0;
            for (var i = 0; i < this.inbox.length; i++) {

                let m = this.inbox[i];
                if (m['id'] == this.emailToShow['id']) {
                    this.inbox.splice(i, 1);
                    break;
                }
            }
        }
    }

    spostaEmailInCoda() {

        if (this.emailToShow != null) {
            this.popEmail();
            var arrayClone = this.inbox.slice();
            arrayClone.push(this.emailToShow);
            this.inbox = arrayClone;
        }
    }


    removeMenuLeft() {
        $(".m-brand--skin-dark ").hide();
        $(".m-aside-left").hide();
        $(".m-footer").hide();

        $("#m_aside_left_offcanvas_toggle").hide();

    }

    removeHeader() {
        $('.m-header').hide();
        $(".m-body").css('margin-top', '-70px');
    }
}


// WEBPACK FOOTER //
// ./src/app/theme/pages/default/cybersecurity/home/utente.component.ts